import React, { Fragment, useEffect, useState, useCallback } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import _ from "lodash"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import ContentEditor from "lib/units/content/ContentEditor"
import { Forms } from "lib/components/forms"


export default function Content(){

  const [ searchParams, setSearchParams ] = useSearchParams()

  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const defaultContentData = { title: "New Content Item", description: "", value: "" }

  const { data:_Snippets } = queryTools.resource.parseQueryForApi("content.findAll", { snippet: true })
  const { data:_Content } = queryTools.resource.parseQueryForApi("content.findAll", { _id: searchParams.get("id") }, { enabled: !!searchParams.get("id") !== null })
  const saveMethod = queryTools.resource.save(["content.all"])

  const [ contentFormData, setContentFormData ] = useState<any>()
  const [ selectedSnippet, setSelectedSnippet ] = useState<any>(undefined)

  const saveContent = async (e:any) => {
    e.preventDefault()
    let contentToSave = contentFormData
    //return console.log("Content to save: ", contentToSave)
    saveMethod.mutate({ resource: "content", data: {...contentToSave, _id: contentToSave._id} })
  }

  const handleInputChange = (e:any) => setContentFormData({ ...contentFormData, [e.target.name]: e.target.value })
  const handleEditorChange = (value:string) => {
    setContentFormData((prev:any) => { 
      console.log(prev)
      return {
        ...prev, 
        value: value 
      }
    })
  }

  // useEffect(() => {
  //   if( _Contents ){
  //     console.log(_Contents)
  //   }
  // },[_Contents])

  useEffect(() => {
    const id = searchParams.get("id")
    if( id !== undefined && id != "0" && _Content !== undefined ){
      setContentFormData(_Content)
    } else if (id == "0") {
      // if no content id is found, load an empty content object
      setContentFormData(defaultContentData)
    }
  },[_Content, searchParams.get("id")])

  if( !contentFormData ) return <></>
  return(
    <div className="w-full max-h-[40rem] border border-solid border-slate-700 p-[2px]">
      <div className="w-full h-8 pl-6 pr-3 flex justify-between items-center bg-slate-700">
        <div className="w-9/12 flex items-center text-white text-sm uppercase">Edit Content: { contentFormData?.title }</div>
        <div className="w-3/12 flex justify-end items-center text-white text-sm"> 
          { _Snippets && _Snippets.length > 0 && (
            <select 
              onChange={(e:any) => {
                setContentFormData((prev:any) => ({...prev, value: `${contentFormData.value}${e.target.value}`}));
              }}
              value=""
              className="w-full h-full border border-solid border-slate-800 text-sm bg-slate-800"
            >
              <option value="">Choose a Snippet</option>
              { _Snippets.map((snippet:any) => (
                <option 
                  key={snippet._id} 
                  value={snippet.value} 
                >
                  {snippet.title}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
      <div className="w-full flex flex-col px-4 py-2">
        <Forms.Form className="w-full flex flex-col gap-3" onSubmit={saveContent}>
          <Forms.FieldGroup label="Title" className="w-full">
            <Forms.InputField 
              type="text" 
              name="title" 
              value={contentFormData.title} 
              onChange={handleInputChange}  
            />
          </Forms.FieldGroup>

          <Forms.FieldGroup label="Description" className="w-full">
            <Forms.Textarea 
              name="description" 
              className="h-16"
              value={contentFormData.description} 
              onChange={handleInputChange}  
            />
          </Forms.FieldGroup>

          <Forms.FieldGroup label="Display" className="w-full">
            <ContentEditor 
              elemtype="opening_statements"
              ctype="pass"
              location="contentmgr"
              value={contentFormData.value} 
              changeFn={(value:string) => handleEditorChange(value)} 
            />
          </Forms.FieldGroup>

          <Forms.FieldGroup className="mt-1 w-full flex flex-row justify-center">
            <button className="relative m-0 w-full border border-solid border-teal-800 rounded h-8 px-4 bg-teal-900 uppercase text-sm">
              Save Changes
            </button>
          </Forms.FieldGroup>

        </Forms.Form>
      </div>
    </div>
  )
}